import React, { useState, useEffect } from "react";
import "./Profile.css";
import { Icon } from "@iconify/react";
import Layout from "../Layout";
import profileImg from "../../Assets/Images/man.png";
import axios from "axios";
import { BigText } from "../../Assets/CSS/Text";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Profile = () => {
  const [userData, setUserData] = useState(null);
  const [formData, setFormData] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [profileImage, setProfileImage] = useState(profileImg);
  const [loading, setLoading] = useState(true); // new loading state
  const fetchProfileData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps/my`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      console.log("Profile API response:", response.data);
      setUserData(response.data);
      setFormData(response.data);
    } catch (error) {
      console.error("Error fetching profile:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfileData();
  }, []);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageURL = URL.createObjectURL(file);
      setProfileImage(imageURL);
      // To upload photo to backend, use FormData and axios POST/PUT if required
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditToggle = () => setEditMode(true);

  const handleCancel = () => {
    setFormData(userData);
    setEditMode(false);
  };

  const handleSave = async () => {
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps/my`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      alert("Profile updated successfully!");
      setUserData(formData);
      setEditMode(false);
    } catch (error) {
      console.error("Error updating profile:", error);
      alert("Failed to update profile.");
    }
  };

  const renderField = (label, name, type = "text") => (
    <div className="field-group" key={name}>
      <label htmlFor={name}>{label}</label>
      {loading ? (
        <Skeleton width="100%" height={35} />
      ) : (
        <input
          id={name}
          name={name}
          type={type}
          value={formData?.[name] || ""}
          readOnly={!editMode}
          onChange={handleChange}
        />
      )}
    </div>
  );

  // if (!userData) return <div>Loading...</div>;

  return (
    <Layout>
      <div className="backgound-main-content">
        <div className="main-content profile-container">
          <div className="profile-container">
            <div className="profile-header">
              <h2 style={BigText} >My Profile</h2>
            </div>

            <div className="profile-info">
              <div className="profile-left">
                <div className="profile-picture">
                  {/* <img
                  // src={profileImage}
                   
                  alt="User Profile"
                  className="profile-picture"
                  onClick={() =>
                    editMode && document.getElementById("imageUpload").click()
                  }
                /> */}
                  {loading ? (
                    <Skeleton circle={true} width={100} height={100} />
                  ) : (
                    <div
                      className="rounded-circle d-flex justify-content-center align-items-center"
                      style={{
                        width: "100px",
                        height: "100px",
                        fontSize: "12px",
                        color: "#999",
                        backgroundColor: "#F0F0F0",
                        border: "1px solid #F0F0F0 ",
                      }}
                    >
                      <Icon
                        icon="proicons:person"
                        className="fs-1 "
                        style={{}}
                      />
                    </div>
                  )}
                  {editMode && !loading && (
                    // {editMode && (
                    <div
                      className="edit-icon-overlay"
                      onClick={() =>
                        document.getElementById("imageUpload").click()
                      }
                    >
                      <Icon icon="mdi:edit" className="edit-icons" />
                    </div>
                  )}
                  <input
                    id="imageUpload"
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={handleImageChange}
                  />
                </div>
                <h3 className="name">
                  {/* {formData.firstName} {formData.lastName} */}
                  {loading ? <Skeleton width={120} /> : `${formData.firstName} ${formData.middleName || ''} ${formData.lastName}`}
                </h3>
              </div>

              {/* {!editMode ? (
              <button className="edit-btn" onClick={handleEditToggle}>
                <Icon icon="mdi:pencil" />
                Edit
              </button>
            ) : (
              <div className="action-buttons">
                <button className="save-btn" onClick={handleSave}>
                  Save
                </button>
                <button className="cancel-btn" onClick={handleCancel}>
                  Cancel
                </button>
              </div>
            )} */}
            </div>


            <div className="row profile-fields">
              {[
                // { label: "First Name", name: "firstName" },
                // { label: "Middle Name", name: "middleName" },
                // { label: "Last Name", name: "lastName" },
                { label: "Date of Birth", name: "dateOfBirth", type: "date" },
                { label: "Date of Joining", name: "dateOfJoining", type: "date" },
                { label: "Department", name: "departmentName" },
                { label: "Designation", name: "designation" },
                { label: "Manager Name", name: "managerName" },
                { label: "Personal Email", name: "personalEmail" },
                { label: "Office Email", name: "officeEmail" },
                { label: "Mobile", name: "mobileNumber" },
                { label: "Employee ID", name: "empId" },
                { label: "Tenant Name", name: "tenantName" },
              ].map((field) => (
                <div className="col-12 col-md-6 col-lg-4 mb-3" key={field.name}>
                  {renderField(field.label, field.name, field.type)}
                </div>
              ))}
            </div>

            {/* Address Information Section */}
            {/* {formData?.address?.Office && (
  <div className="address-section mt-4">
    <h4 className="address-title"> Address</h4>
    <div className="row">
      <div className="col-12 col-md-6 col-lg-4 mb-3">
        <div className="field-group">
          <label>Street Line 1</label>
          {loading ? (
            <Skeleton width="100%" height={35} />
          ) : (
            <input
              type="text"
              value={formData.address.Office.streetLine1 || ""}
              readOnly={!editMode}
              onChange={(e) => {
                setFormData(prev => ({
                  ...prev,
                  address: {
                    ...prev.address,
                    Office: {
                      ...prev.address.Office,
                      streetLine1: e.target.value
                    }
                  }
                }));
              }}
            />
          )}
        </div>
      </div>
      <div className="col-12 col-md-6 col-lg-4 mb-3">
        <div className="field-group">
          <label>Street Line 2</label>
          {loading ? (
            <Skeleton width="100%" height={35} />
          ) : (
            <input
              type="text"
              value={formData.address.Office.streetLine2 || ""}
              readOnly={!editMode}
              onChange={(e) => {
                setFormData(prev => ({
                  ...prev,
                  address: {
                    ...prev.address,
                    Office: {
                      ...prev.address.Office,
                      streetLine2: e.target.value
                    }
                  }
                }));
              }}
            />
          )}
        </div>
      </div>
      <div className="col-12 col-md-6 col-lg-4 mb-3">
        <div className="field-group">
          <label>City</label>
          {loading ? (
            <Skeleton width="100%" height={35} />
          ) : (
            <input
              type="text"
              value={formData.address.Office.city || ""}
              readOnly={!editMode}
              onChange={(e) => {
                setFormData(prev => ({
                  ...prev,
                  address: {
                    ...prev.address,
                    Office: {
                      ...prev.address.Office,
                      city: e.target.value
                    }
                  }
                }));
              }}
            />
          )}
        </div>
      </div>
      <div className="col-12 col-md-6 col-lg-4 mb-3">
        <div className="field-group">
          <label>State</label>
          {loading ? (
            <Skeleton width="100%" height={35} />
          ) : (
            <input
              type="text"
              value={formData.address.Office.state || ""}
              readOnly={!editMode}
              onChange={(e) => {
                setFormData(prev => ({
                  ...prev,
                  address: {
                    ...prev.address,
                    Office: {
                      ...prev.address.Office,
                      state: e.target.value
                    }
                  }
                }));
              }}
            />
          )}
        </div>
      </div>
      <div className="col-12 col-md-6 col-lg-4 mb-3">
        <div className="field-group">
          <label>Postal Code</label>
          {loading ? (
            <Skeleton width="100%" height={35} />
          ) : (
            <input
              type="text"
              value={formData.address.Office.postalCode || ""}
              readOnly={!editMode}
              onChange={(e) => {
                setFormData(prev => ({
                  ...prev,
                  address: {
                    ...prev.address,
                    Office: {
                      ...prev.address.Office,
                      postalCode: e.target.value
                    }
                  }
                }));
              }}
            />
          )}
        </div>
      </div>
      <div className="col-12 col-md-6 col-lg-4 mb-3">
        <div className="field-group">
          <label>Country</label>
          {loading ? (
            <Skeleton width="100%" height={35} />
          ) : (
            <input
              type="text"
              value={formData.address.Office.country || ""}
              readOnly={!editMode}
              onChange={(e) => {
                setFormData(prev => ({
                  ...prev,
                  address: {
                    ...prev.address,
                    Office: {
                      ...prev.address.Office,
                      country: e.target.value
                    }
                  }
                }));
              }}
            />
          )}
        </div>
      </div>
    </div>
  </div>
)} */}



            {editMode && (
              <div className="mobile-buttons">
                <button className="save-btn" onClick={handleSave}>
                  Save
                </button>
                <button className="cancel-btn" onClick={handleCancel}>
                  Cancel
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Profile;
